import type { NotificationAsyncDeletePayload } from "../notification-async-delete.type";

import { MAX_ITEM_NAMES } from "./notification-async-delete-success-description.constant";

export const getNotificationParams = (
  payload: NotificationAsyncDeletePayload
) => {
  const i18nKey = getTranslationKey(payload);
  const modelNames = extractModelNames(payload);
  const count = Math.max(payload.models.length - MAX_ITEM_NAMES, 0);

  return { i18nKey, modelNames, count };
};

export const extractModelNames = (payload: NotificationAsyncDeletePayload) => {
  if (
    payload.is_batch_processing &&
    payload.models.length > MAX_ITEM_NAMES + 1
  ) {
    return payload.models
      .slice(0, MAX_ITEM_NAMES)
      .map((model) => model.name)
      .join(", ");
  }
  return payload.models.map((model) => model.name).join(", ");
};

export const getTranslationKey = (
  payload: NotificationAsyncDeletePayload
): string => {
  const { is_batch_processing, models } = payload;
  const modelType = models[0].type;

  if (modelType === "organization")
    return "notification:asyncDelete.description.success.organization";
  if (modelType === "location")
    return "notification:asyncDelete.description.success.location";
  if (is_batch_processing && models.length > MAX_ITEM_NAMES + 1)
    return "notification:asyncDelete.description.success.assetBatch";
  if (is_batch_processing)
    return "notification:asyncDelete.description.success.assets";
  return "notification:asyncDelete.description.success.asset";
};
